import {
  BusinessRegistrationAuthority,
  BusinessType,
} from '../hooks/useBusinessRegistration';
import { FREE_EMAIL_DOMAINS } from './constants';

// Helper to get business registration field config based on country
export const getBusinessRegFieldConfig = (countryCode: string) => {
  const configs: {
    [key: string]: {
      label: string;
      placeholder: string;
      pattern?: RegExp;
      patternMessage?: string;
    };
  } = {
    US: {
      label: 'Employer Identification Number (EIN)',
      placeholder: 'Enter 9 digit EIN',
      pattern: /^\d{9}$/,
      patternMessage: 'EIN must be 9 digits',
    },
    CA: {
      label: 'Canadian Business Number (BN)',
      placeholder: 'Enter 9 digit BN',
      pattern: /^\d{9}$/,
      patternMessage: 'BN must be 9 digits',
    },
    GB: {
      label: 'Company Number (CN)',
      placeholder: 'Enter CN (e.g., 12345678 or SC123456)',
      pattern: /^([A-Z]{2}\d{6}|\d{8})$/,
      patternMessage: 'CN must be 8 digits or 2 letters followed by 6 digits',
    },
    AU: {
      label: 'Australian Company Number from ASIC (ACN)',
      placeholder: 'Enter 9 digit ACN',
      pattern: /^\d{9}$/,
      patternMessage: 'ACN must be 9 digits',
    },
  };

  return (
    configs[countryCode] || {
      label: 'Business Registration Identifier',
      placeholder: 'Enter Business Registration Identifier',
    }
  );
};

// Helper to map country code to BusinessRegistrationAuthority
export const getRegistrationAuthority = (
  countryCode: string,
): BusinessRegistrationAuthority => {
  const authorityMap: { [key: string]: BusinessRegistrationAuthority } = {
    US: BusinessRegistrationAuthority.EIN,
    CA: BusinessRegistrationAuthority.CBN,
    GB: BusinessRegistrationAuthority.CN,
    AU: BusinessRegistrationAuthority.ACN,
  };

  return authorityMap[countryCode] || BusinessRegistrationAuthority.OTHER;
};

// Helper to map form business type to backend enum
export const mapBusinessTypeToEnum = (
  formBusinessType: string,
): BusinessType => {
  return formBusinessType === 'sole-proprietor'
    ? BusinessType.SOLE_PROPRIETOR
    : BusinessType.PRIVATE_PROFIT;
};

// Helper to check if an email domain is a free email provider
export const isFreeEmailDomain = (email: string): boolean => {
  if (!email) return false;
  const domain = email.split('@')[1]?.toLowerCase();
  return domain ? FREE_EMAIL_DOMAINS.includes(domain) : false;
};
